import { BrowserRouter, Route, Routes } from "react-router-dom";
import routingObject from "./routes";
import { ACL } from "../components/acl";

function Routers() {
  const resolveRoles = (router) => {
    if (!router.role || router.role.includes("*")) {
      return router.element;
    } else {
      return (
        router.element ? <ACL showFor={router.role} redirectTo={"/not-found"}>
          {router.element}
        </ACL> : null
      );
    }
  };

  const routerChildMap = (routes, parentRole) =>
    routes.map((route, index) => {
      if (route.children) {
        return (
          <Route
            key={"child_" + Math.random(index)}
            path={route.path || "/"}
            element={resolveRoles({ ...route, role: route.role || parentRole })}
          >
            {routerChildMap(route.children)}
          </Route>
        );
      } else {
        return (
          <Route
            key={"child_" + Math.random(index)}
            path={route.path || "/"}
            element={resolveRoles({ ...route, role: route.role || parentRole })}
          />
        );
      }
    });

  const routerMap = () =>
    routingObject.map((route, index) => {
      if (route.children) {
        return (
          <Route
            key={"parent_" + Math.random(index)}
            errorElement={route.errorElement || ""}
            path={route.path || "/"}
            element={resolveRoles(route)}
          >
            {routerChildMap(route.children, route.role)}
          </Route>
        );
      } else {
        return (
          <Route
            key={"parent_" + Math.random(index)}
            path={route.path || "/"}
            element={resolveRoles(route)}
          />
        );
      }
    });

  console.log(routerMap(), "ROUTES")
  return (
    <BrowserRouter basename={process.env.REACT_APP_BASEURL}>
      <Routes>{routerMap()}</Routes>
    </BrowserRouter>
  );
}

export default Routers;
